module.exports = __webpack_public_path__ + "media/images/pic/lectors/natalia-wojcik-27e17c19f0eaa9f9f2269e608761508c.jpeg";